import React, { useEffect, useState } from "react";
import CollegePageContainer from "../Container/CollegePageContainer";
import { connect } from "react-redux";
import "./UserManual.css"
import SearchBar from "../../Components/SearchBar/SearchBar";
import ReactTooltip from "react-tooltip";
import { ShareVideoModal } from "./ShareVideoModal";

const CollegeUserManual = (props) => {
  const videos = [
    {
      "id": "18ecbaf3486540a5a4e34104729a32cf",
      "name": props.currentUser.is_childcare_centre ? "Setup Provider Profile & Centres" : "Setup Provider Profile & Campuses",
      "keywords": "get started, account setup",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Education+Provider+Tutorial+1_+Setup+Provider+Profile+%26+Campuses.mp4"
    },
    { 
      "id": "82159c023523424bad425aef82bf6e9a",
      "name": props.currentUser.is_childcare_centre ? "Add Centre & Shift records" : "Add Campus & Timetable records",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Add+Campus+%26+Timetable+records+(no+sound).mp4" },
    {
      "id": "f7774e56b50f4c87ab75c167672ae7d7",
      "name": "Add Personnel record",
      "keywords": "add user",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Add+Personnel+record+(No+sound)+-+3+July+2022.mp4"
    },
    {
      "id": "9718c9c0034d43398f5f3a13367b93c8",
      "name": props.currentUser.is_childcare_centre ? "Five Ways to Book a Educator" : "Five Ways to Book a Teacher",
      "keywords": "make booking, make a booking",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Five+Ways+to+Book+a+Teacher+(No+sound)+-+19+March+2023.mp4"
    },
    {
      "id": "fced166abfaf4c69a400297578c04045",
      "name": props.currentUser.is_childcare_centre ?"Book a Specific Educator" : "Book a Specific Teacher",
      "keywords": "specific, individual, name",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Book+a+Specific+Teacher+-+3+August+2022.mp4"
    },
    {
      "id": "6c8739e9c9f0409f99bf1150bb983017",
      "name": props.currentUser.is_childcare_centre ? "Create a special timetable for a specific Educator" : "Create a special timetable for a specific teacher",
      "keywords": "specific, individual, name",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Create+a+special+timetable+for+a+specific+teacher+-+16+August+2022.mp4"
    },
    { "id": "4e6a6d02ae904bfa99e37c387b057688", "name": "How to use your Calendar", "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/How+to+use+your+Calendar+-+1+December+2022.mp4" },
    {
      "id": "9b7e1fa98f344f10bab010940d5ee784",
      "name": "How to Change Class Level/Type",
      "name": props.currentUser.is_childcare_centre ? "How to Change Shift Level/Type" : "How to Change Class Level/Type",
      "keywords": "level, change level, edit level, edit class",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/How+to+Change+Class+Level_Type+-+19+December+2022.mp4"
    },
    { "id": "088cc8e059c843ea84ea2ca32f479b0d", "name": "Cancel a Booking", "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Cancel+a+Booking+-+7+October+2022.mp4" },
    { "id": "3cde2bdaee384cf2b4db1fd5d4d8104b", "name": "How to Cancel Single Days", "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/How+to+Cancel+Single+Days+-+8+November+2022.mp4" },
    {
      "id": "add12c793bd443a9848d573c0c324b2b",
      "name": "Send Lesson Plan/Materials",
      "keywords": "lesson plan, lesson materials, materials, send materials",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Send+Lesson+Plan_Materials+-+19+January+2023.mp4"
    },
    {
      "id": "043415a5c28f42c398d2924d4f197fb3",
      "name": "How to Export Calendar to .CSV",
      "keywords": "export calendar, export, excel",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/How+to+Export+Calendar+to+.CSV-+4+January+2023.mp4"
    },
    {
      "id": "579c6279d8b2406bab1c463b3976aad5",
      "name": "How to Create a Job Listing",
      "keywords": "job listing, listing, vacancy, job ad",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/How+to+Create+a+Job+Listing+-+11+July+2022.mp4"
    },
    {
      "id": "fe83921327f44a1480c980e67111689b",
      "name": "How to Schedule an Interview",
      "keywords": "interview, schedule interview",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/How+to+Schedule+an+Interview+-+28+September+2022.mp4"
    },
    {
      "id": "b5ceaea3b9fe5f4fedf7aea0b6cada08",
      "name": "Request to View Teacher's Availability",
      "keywords": "availability, calendar",
      "link": "https://college-introduction.s3.ap-southeast-2.amazonaws.com/Request+to+View+Teacher's+Availability.mp4"
    },
  ]
  const [filteredVideos, setFilteredVideos] = useState(videos)
  const [sharedVideo, setSharedVideo] = useState(undefined)

  const search = (e) => {
    const keyword = e.target.value?.toLowerCase()
    const searchVideos = videos.filter(v => (v.name + " " + v.keywords).toLowerCase().includes(keyword))
    setFilteredVideos(searchVideos)
  }

  useEffect(() => {
    let hash = window.location.hash;
    if (hash) {
      let id = hash?.slice(1);
      let elementId = document.getElementById(id);
      if(id && elementId) {
        elementId.scrollIntoView({
          behavior: "smooth",
          block: "center",
        })
      }
    }
  })

  return (
    <CollegePageContainer user={props.user} header="User Manual">
      <div className="row ml-4 mr-5 my-4">
        <SearchBar
          onChange={search}
        />
      </div>

      <div className="row mx-2">
        {filteredVideos.map(v => <div className="col-md-6 mt-3 mb-4">
            <div>
              <h3 className="text-center">{v.name}</h3>
              <button
                className="btn btn-primary share-video-button ml-3"
                data-tip="Share Video"
                data-for="share-video"
                onClick={() => {
                  setSharedVideo(v);
                }}
              >
                <a
                  className="mdi mdi-share share-video-icon"
                />
                <ReactTooltip
                  place="top"
                  backgroundColor="rgb(47, 224, 222)"
                  effect="solid"
                  id="share-video"
                />
              </button>
            </div>
            <div
              className="help-video-container mt-3"
              id={v.id}
            >
              <video controls>
              <source src={v.link}
                  type="video/mp4"/>
              </video>
            </div>
          </div>
        )}

        {sharedVideo && <ShareVideoModal video={sharedVideo} onClose={() => setSharedVideo(undefined)} />}

      </div>
    </CollegePageContainer>
  );
};

function mapStateToProps(state) {
  return {
    user: state?.user?.user,
    currentUser: state.college.user,
  };
}

export default connect(mapStateToProps)(CollegeUserManual);